import React, { useState, useEffect } from "react";
import "./UserDetails.scss";
import { UserRolesEnum } from "../../enum/enums";
import EyeIcon from "../../assets/icons/EyeIcon";
import EyeOffIcon from "../../assets/icons/EyeOffIcon";
import { getRoleName } from "../../utils/common";
import masterApi from "../../services/masterApi";
import ConfirmationModal from "../../components/confirmationModal/ConfirmationModal";

const BASE_URL = process.env.REACT_APP_API_URL;

const UserDetails = ({ userData, closePopin, onButtonClick }) => {
  const [inputType, setInputType] = useState("password");
  const [isExpertiseRequired, setExpertiseRequired] = useState(false);
  const [showGeneratedPassword, setShowGeneratedPassword] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false); // Modal visibility
  
  const toggleInputType = () => {
    setInputType((prevType) => (prevType === "password" ? "text" : "password"));
  };

  const handleEditClick = () => {
    onButtonClick(userData);
  };
  const closeModal = () => {
    setIsModalVisible(false);    
  }; 
  const openModal = () => {
    setIsModalVisible(true);    
  }; 

  const GeneratePassword = async () => {
    try {
      setShowGeneratedPassword(true);
      const data = { userId: userData._id };
      const response = await masterApi.hardresetpassword(data);
      console.log("API Response:", response);
      if(response?.data?.ok){
        userData.password = response?.data?.password;        
        setIsModalVisible(false);
        setInputType("text");
      }      
    } catch (error) {
      console.error("Error resetting password:", error);      
    }
  };

  useEffect(() => {
    if (userData?.userRole === UserRolesEnum.TECHINICIAN) {
      setExpertiseRequired(true);
    } else {
      setExpertiseRequired(false);
    }
  }, [userData?.userRole,showGeneratedPassword]);

  return (
    <div className="popIn-inner-wrapper">
      <div className="user-details">
        <div className="user">
          <div className="user-image">
            <img
              className="user-image"
              src={BASE_URL + userData.profileImagePath}
              alt="User"
            />
          </div>
          <div className="name">
            {userData.firstName + " " + userData.lastName}
          </div>
          <div className="position">{getRoleName(userData.userRole)}</div>
        </div>
        <div className="details">
          <div className="detail-section">
            <label>User Name</label>
            <div className="text">{userData.username}</div>
          </div>
          {userData.email && (
            <div className="detail-section">
              <label>Email</label>
              <div className="text">{userData.email}</div>
            </div>
          )}
          <div className="detail-section">
            <label>Phone</label>
            <div className="text">{userData.mobile}</div>
          </div>
          {isExpertiseRequired && (
            <div className="detail-section">
              <label>Expertise</label>
              <div className="text">
                {userData.expertises?.map((expertise) => expertise.expertiseName).join(", ") || "N/A"}
              </div>
            </div>
          )}
          {userData.showPassword || showGeneratedPassword ? (
            <div className="detail-section">
              <label>Password</label>
              <div className="password">
                <input type={inputType} value={userData.password} readOnly />
                <button className="btn view" onClick={toggleInputType}>
                  {inputType !== "password" ? <EyeIcon /> : <EyeOffIcon />}
                </button>
              </div>
            </div>
          ) : (
            !userData.email && (
              <button
                className="btn btn-secondary px-3 py-1"
                onClick={() => openModal()}
              >
                Generate New Password
              </button>
            )
          )}
          
        </div>
      </div>
      <div className="action-btn">
        <button className="cancel secondary-btn" onClick={closePopin}>
          Cancel
        </button>
        <button
          className="save primary-btn"
          id="editorBtn"
          onClick={handleEditClick}
        >
          Edit
        </button>
      </div>
      {isModalVisible && (
        <ConfirmationModal
          show={isModalVisible}
          title="Generate New Password"
          message={`Do you want to generate new password for this user ?`}
          onConfirm={GeneratePassword} // Call to confirm deletion
          onCancel={closeModal} // Close modal if canceled
          confirmText="Yes, Generate"
          cancelText="No, Cancel"
        />
      )}
    </div>
  );
};

export default UserDetails;
